export class StringSet {
  private _items: Record<string, number> = {};
  private _nums: Record<number, number> = {};
  private _length: number = 0;

  constructor(items?: (string | number)[]) {
    if (!items) return;
    this._length = 0;
    for (let i = 0; i < items.length; i++) {
      this.add(items[i]);
      if (items[i] === undefined) continue;
      if (typeof items[i] === 'string') {
        this._items[items[i]] = i;
      } else {
        this._nums[<any>items[i]] = i;
      }
    }
  }

  public add(x: string | number): this {
    if (this.has(x)) return this;
    this._length++;
    if (typeof x === 'string') {
      this._items[x] = this._length;
    } else {
      this._nums[x] = this._length;
    }
    return this;
  }

  public delete(x: string | number): this {
    if (!this.has(x)) return this;
    this._length--;
    if (typeof x === 'string') {
      delete this._items[x];
    } else {
      delete this._nums[x];
    }
    return this;
  }

  public has(x: any): boolean {
    if (typeof x !== 'string' && typeof x !== 'number') return false;
    return this._items[x] !== undefined || this._nums[<any>x] !== undefined;
  }

  public values(): (string | number)[] {
    const values: { k: string | number; v: number }[] = [];

    Object.keys(this._items).forEach((k) => {
      values.push({ k, v: this._items[k] });
    });

    Object.keys(this._nums).forEach((k) => {
      values.push({ k: parseFloat(k), v: this._nums[+k] });
    });

    return values
      .sort((a, b) => a.v - b.v)
      .map((a) => a.k);
  }

  public clear(): this {
    this._length = 0;
    this._items = {};
    this._nums = {};
    return this;
  }

  public size(): number {
    return this._length;
  }
}
